module.exports = __webpack_public_path__ + "static/wordmark-42dfcc0b2269fd4f0010b429ac638db5.png";